import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const getStoriesState = (state: RootState) => state.stories;

export const selectAllStories = createSelector(
  [getStoriesState],
  (stories) => stories.allStories.data
);

export const selectLoadingAllStories = createSelector(
  [getStoriesState],
  (stories) => stories.loadingAllStories
);

export const selectAllStoriesError = createSelector(
  [getStoriesState],
  (stories) => stories.allStoriesError
);

export const selectSuggestedStories = createSelector(
  [getStoriesState],
  (stories) => stories.suggestedStories.data
);

export const selectSuggestedStoriesContinuationToken = createSelector(
  [getStoriesState],
  (stories) => stories.suggestedStories.xMsContinuationToken
);

export const selectHasMoreSuggestedStories = createSelector(
  [getStoriesState],
  (stories) => !!stories.suggestedStories.xMsContinuationToken
);

export const selectLoadingSuggestedStories = createSelector(
  [getStoriesState],
  (stories) => stories.loadingSuggestedStories
);

export const selectAllStoriesContinuationToken = createSelector(
  [getStoriesState],
  (stories) => stories.allStories.xMsContinuationToken
);

export const selectHasMoreAllStories = createSelector(
  [getStoriesState],
  (stories) => Boolean(stories.allStories.xMsContinuationToken)
);

export const selectFollowingStories = createSelector(
  [getStoriesState],
  (stories) => stories.followingStories.data
);

export const selectLoadingFollowingStories = createSelector(
  [getStoriesState],
  (stories) => stories.loadingFollowingStories
);

export const selectFollowingStoriesError = createSelector(
  [getStoriesState],
  (stories) => stories.followingStoriesError
);

export const selectFollowingStoriesContinuationToken = createSelector(
  [getStoriesState],
  (stories) => stories.followingStories.xMsContinuationToken
);

export const selectHasMoreFollowingStories = createSelector(
  [getStoriesState],
  (stories) => Boolean(stories.followingStories.xMsContinuationToken)
);

export const selectMyStories = createSelector(
  [getStoriesState],
  (stories) => stories.myStories.data
);

export const selectMyStoriesError = createSelector(
  [getStoriesState],
  (stories) => stories.myStoriesError
);

export const selectMyStoriesContinuationToken = createSelector(
  [getStoriesState],
  (stories) => stories.myStories.xMsContinuationToken
);

export const selectLoadingMyStories = createSelector(
  [getStoriesState],
  (stories) => stories.loadingMyStories
);

export const selectHasMoreMyStories = createSelector(
  [getStoriesState],
  (stories) => Boolean(stories.myStories.xMsContinuationToken)
);

export const selectStoryTags = createSelector(
  [getStoriesState],
  (stories) => stories.storyTags
);

export const selectLoadingStoryTags = createSelector(
  [getStoriesState],
  (stories) => stories.loadingStoryTags
);

export const selectStoryTopics = createSelector(
  [getStoriesState],
  (stories) => stories.storyTopics
);

export const selectLoadingStoryTopics = createSelector(
  [getStoriesState],
  (stories) => stories.loadingStoryTopics
);

export const selectMyStoryStats = createSelector(
  [getStoriesState],
  (stories) => stories.myStoryStats
);

export const selectMyPublishedStoriesCount = createSelector(
  [getStoriesState],
  (stories) => stories.myStoryStats?.published
);

export const selectLoadingMyStoryStats = createSelector(
  [getStoriesState],
  (stories) => stories.loadingMyStoryStats
);

export const selectFullStory = createSelector(
  [getStoriesState],
  (stories) => stories.fullStory
);

export const selectLoadingFullStory = createSelector(
  [getStoriesState],
  (stories) => stories.loadingFullStory
);

export const selectEditedStory = createSelector(
  [getStoriesState],
  (stories) => stories.editedStory
);

export const selectCurrentStorySettings = createSelector(
  [getStoriesState],
  (stories) => stories.currentStorySettings
);

export const selectPublishInProgress = createSelector(
  [getStoriesState],
  (stories) => stories.publishInProgress
);

export const selectStoriesByAuthor = createSelector(
  [getStoriesState],
  (stories) => stories.storiesByAuthor?.data ?? []
);

export const selectStoriesByAuthorContinuationToken = createSelector(
  [getStoriesState],
  (stories) => stories.storiesByAuthor?.xMsContinuationToken
);

export const selectLoadingStoriesByAuthor = createSelector(
  [getStoriesState],
  (stories) => stories.loadingStoriesByAuthor
);

export const selectStoriesByTopic = createSelector(
  [getStoriesState],
  (stories) => stories.storiesByTopic.data
);

export const selectStoriesByTopicContinuationToken = createSelector(
  [getStoriesState],
  (stories) => stories.storiesByTopic.xMsContinuationToken
);

export const selectHasMoreStoriesByTopic = createSelector(
  [getStoriesState],
  (stories) => !!stories.storiesByTopic.xMsContinuationToken
);

export const selectHasMoreStoriesByAuthor = createSelector(
  [getStoriesState],
  (stories) => !!stories.storiesByAuthor.xMsContinuationToken
);

export const selectLoadingStoriesByTopic = createSelector(
  [getStoriesState],
  (stories) => stories.loadingStoriesByTopic
);

export const selectTitleTopicName = createSelector(
  [getStoriesState],
  (stories) => stories.titleTopicName
);

export const selectStoryError = createSelector(
  [getStoriesState],
  (stories) => stories.storyError
);

export const selectOpenShareStoryToRoomsDialog = createSelector(
  [getStoriesState],
  (stories) => stories.openShareStoryToRoomsDialog
);

export const selectShareStory = createSelector(
  [getStoriesState],
  (stories) => stories.shareStory
);

export const selectIsStoryOffensive = createSelector(
  [getStoriesState],
  (stories) => stories.isStoryOffensive
);

export const selectEditedFeaturedStory = createSelector(
  [getStoriesState],
  (stories) => stories.editedFeaturedStory
);

export const selectEditedFeaturedContent = createSelector(
  [getStoriesState],
  (stories) => stories.editedFeaturedContent
);
